
<v-col class="home" align-center>
  <v-stepper v-model="activeStep" class="stepper" :non-linear="true" @change="onStepChange">
    <v-stepper-header class="stepper-header elevation-3">
      <v-stepper-step :complete="activeStep > 1" step="1" editable>{{ $t("ORDER_STEP_1") }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="activeStep > 2" step="2" :editable="allowStep2And3" edit-icon="photo_library">
        {{ $t("ORDER_STEP_2") }}
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="activeStep > 3" step="3" :editable="allowStep2And3">
        {{ $t("ORDER_STEP_3") }}
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <CodeSubmission/>
      </v-stepper-content>

      <v-stepper-content step="2">
        <ImagePresentation ref="imagePresentation"/>
      </v-stepper-content>

      <v-stepper-content step="3">
        <Products/>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</v-col>
